import React, { useState, useEffect, useRef } from "react";
import { Affix, Col, Container, Content, FlexboxGrid, Header, Input, InputGroup, List, Navbar, Panel, Stack, Table } from 'rsuite';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useClearCache } from 'react-clear-cache';
import { useIsMobile } from "../utils/useIsMobile";
import loader from "assets/img/init.svg";
import axios from "axios";
import r404 from "assets/img/404.svg";
import r403 from "assets/img/403.svg";
import r500 from "assets/img/500.svg";
import r503 from "assets/img/503.svg";
import Catalog from 'components/Catalog.js';

function SearchView() {
    const site = useSelector(state => state.site);
    const params = useSelector(state => state.params);
    const history = useHistory();
    const screenSize = useIsMobile();
    const { isLatestVersion, emptyCacheStorage } = useClearCache();
    const [cookies, setCookie] = useCookies(['uuid']);
    const [reportTitle, setReportTitle] = useState("");
    const [loadingState, setLoadingState] = useState(0);
    const [cssLoaded, setCSSLoaded] = useState(false);
    const [currentState, setCurrentState] = useState("buscando catálogo ...");
    const [articulos, setArticulos] = useState([]);
    const [filteredArticulos, setFilteredArticulos] = useState([]);
    const [groupType, setGroupType] = useState(0);
    const [proyectUser, setProyectUser] = useState({});
    const [validityTo, setValidityTo] = useState('');
    const [iconLogo, setIconLogo] = useState(null);
    const refText = useRef(null);
    const refTimeout = useRef(0);

    const handleChange = (event) => {
        clearTimeout(refTimeout.current)
        refTimeout.current = setTimeout(() => {
            console.log(event.target.value);
        }, 1000);
    };

    const applyFilter = (text) => {
        console.log(text);
        setFilteredArticulos(articulos.filter(x =>
            x.label.toLowerCase().includes(text) ||
            x.proveedor.toLowerCase().includes(text) ||
            x.rubro.toLowerCase().includes(text) ||
            x.subrubro.toLowerCase().includes(text)
        ));
    }

    const fetchData = async () => {
        await axios
            .get(`${site.site.apiServer}/catalogo/view${window.location.pathname}`, { withCredentials: true })
            .then(async (response) => {
                if (response.data.result) {
                    console.log(response);
                    setCurrentState("iniciando ...");
                    setReportTitle(response.data.header);
                    setGroupType(response.data.groupType);
                    setArticulos(response.data.data);
                    setFilteredArticulos(response.data.data);
                    setValidityTo(response.data.validityTo);
                    setProyectUser({
                        printUser: response.data.printUser,
                        contactEmail: response.data.contactEmail,
                        contactName: response.data.contactName,
                        contactPhone: response.data.contactPhone
                    });
                    setTimeout(() => { setLoadingState(1); }, 500);
                }
            })
            .catch((e) => {
                if (e.response && e.response.data && e.response.data.detail === 'NOT_FOUND') {
                    setLoadingState(-1);
                } else if (e.response && e.response.data && e.response.data.detail === 'EXPIRED') {
                    setLoadingState(-2);
                } else if (e.response && e.response.data && e.response.data.detail === 'INACTIVE') {
                    setLoadingState(-3);
                } else {
                    setLoadingState(-4);
                }
            });
    }

    useEffect(() => {
        console.log('useEffect begin');
        site.site != null ? (fetch(site.site.apiServer + '/catalogo/res/logo').then((r) => r.text()).then((r) => setIconLogo(r)).catch(() => { })) : void (0);
        const source = axios.CancelToken.source();
        if (!isLatestVersion) {
            emptyCacheStorage();
            return () => { console.log('useEffect refresh'); };
        }
        const uuid = cookies.uuid ? cookies.uuid : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        if (!cookies.uuid)
            setCookie('uuid', uuid, { path: '/', sameSite: 'none', domain: '.wisesoft.ar', secure: true, expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)) });

        let head = document.head,
            default_css = document.createElement("link"),
            custom_css = document.createElement("link"),
            fonts_css = document.createElement("link");

        default_css.type = "text/css";
        default_css.rel = "stylesheet";
        default_css.href = "./defaultVS.css";

        custom_css.type = "text/css";
        custom_css.rel = "stylesheet";
        custom_css.href = `${site.site.apiServer}/catalogo/res/vs`;

        fonts_css.type = "text/css";
        fonts_css.rel = "stylesheet";
        fonts_css.href = `${site.site.apiServer}/catalogo/res/fonts`;
        fonts_css.onload = (e) => { setCSSLoaded(true); };

        head.appendChild(default_css);
        head.appendChild(custom_css);
        head.appendChild(fonts_css);
        
        return () => {
            head.removeChild(default_css);
            head.removeChild(custom_css);
            head.removeChild(fonts_css);
            if (source) source.cancel('change view'); console.log('useEffect end');
        }
    }, [site]);

    useEffect(() => { fetchData(); }, [cssLoaded]);

    return (
        <div className="wrapper wrapper-full-page">
            <div className="full-page section-image" data-color="black">
                <Container>
                    {loadingState === 1 && cssLoaded && screenSize.isMobile && (
                        <Panel style={{ borderRadius: 0, margin: 0, backgroundColor: '#fff' }}>
                            <Stack spacing={0} justifyContent="space-between" direction={"column"}>
                                <Stack.Item grow={1}>
                                    <img src={(params.brand && params.brand.logo80) ? params.brand.logo80 : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=='} style={{ height: 80, verticalAlign: "bottom" }} />
                                    <div className="view-list-logo-text">
                                        <div>{(params.brand && params.brand.name) ? params.brand.name : ''}</div>
                                        <div>{reportTitle}</div>
                                    </div>
                                </Stack.Item>
                            </Stack>
                        </Panel>
                    )}
                    {(loadingState === 0) && (
                        <FlexboxGrid justify="center">
                            <FlexboxGrid.Item as={Col} colspan={24} md={5} style={{ color: "#fff" }}>
                                <img src={loader} style={{ display: "block", margin: "auto", width: 150 }} alt="loading" />
                                <h5 style={{ marginTop: 20, fontWeight: "normal", textAlign: "center" }}>{currentState}</h5>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    )}
                    {loadingState === 1 && (
                        <>
                            <Header>
                                <div className="search-container">
                                    {iconLogo != null && <div className="brand-logo" dangerouslySetInnerHTML={{ __html: iconLogo }} />}
                                    <div className="search-box">
                                        <div className="iblpc">
                                            <div className="hvhmMe">
                                                <span className="z1asCe">
                                                    <svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path></svg>
                                                </span>
                                            </div>
                                        </div>
                                        <textarea
                                            placeholder="Buscar"
                                            name="searchtext"
                                            ref={refText}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    applyFilter(e.target.value);
                                                }
                                            }}
                                            autoCapitalize="off"
                                            autoComplete="off"
                                            autoCorrect="off"
                                            maxLength="100" rows="1" spellCheck="false"></textarea>
                                    </div>
                                </div>
                            </Header>
                            <Content style={{ padding: "120px 20px 20px 20px"}}>
                                <Catalog key="wise_catalog"
                                    articulos={filteredArticulos}
                                    groupType={groupType}
                                    headerText={reportTitle}
                                    httpOnly={true}
                                    proyectUser={proyectUser}
                                    validityTo={validityTo}
                                    asSearchView={true}
                                />
                            </Content>
                        </>
                    )}
                    {loadingState === -1 && (
                        <FlexboxGrid justify="center">
                            <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                <img src={r404} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>No se encontró el catálogo solicitado</h4>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    )}
                    {loadingState === -2 && (
                        <FlexboxGrid justify="center">
                            <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                <img src={r403} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Expiró la vigencia del catálogo solicitado</h4>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    )}
                    {loadingState === -3 && (
                        <FlexboxGrid justify="center">
                            <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                <img src={r503} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>La publicación se encuentra en pausa...</h4>
                                <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    )}
                    {loadingState === -4 && (
                        <FlexboxGrid justify="center">
                            <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                <img src={r500} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Pedimos disculpas, el servidor no está respondiendo...</h4>
                                <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    )}                        
                </Container>
            </div>
        </div>
    )

}
export default SearchView;